import React from "react";
import Question from "./Question";
import QuestionNum from "./question-number.component";
import QuestionsInfo from "./question-info.component";

import "./question-paper-solution.styles.css";

const QuestionPaper = ({ testObject, changeView, questionWiseAnalysis }) => {
  return (
    <div className="col-md-9 col-sm-9 col-xs-12">
      <div className="testinfo_tab">
        <div className="qustion_div question_paper">
          {testObject?.sections?.map((section, section_index) => (
            <>
              <div className="section_name">
                Section:{" "}
                <span className="label label-success ng-binding">
                  {section.name}
                </span>
              </div>
              {section?.questions?.map((question, question_index) => {
                return (
                  <div className="" id="question">
                    {
                      <QuestionNum
                        questionNumber={question.questionNumber}
                        testObject={testObject}
                      />
                    }
                    <Question question={question} />
                    {questionWiseAnalysis?.sections && (
                      <div
                        className="answer-box"
                        style={{
                          color: `var(${
                            questionWiseAnalysis?.sections[section_index]
                              ?.questions[question_index]?.attemptStatus === 1
                              ? "--success"
                              : "--danger"
                          })`,
                        }}
                      >
                        <span>My Answer: </span>{" "}
                        <span>
                          {questionWiseAnalysis?.sections[section_index]
                            ?.questions[question_index]?.attemptedString ||
                            questionWiseAnalysis?.sections[section_index]
                              ?.questions[question_index]?.textAnswer}
                        </span>{" "}
                        | <span>Correct Answer: </span>{" "}
                        <span>
                          {questionWiseAnalysis?.sections[section_index]
                            ?.questions[question_index]?.correctString ||
                            `${questionWiseAnalysis?.sections[section_index]?.questions[question_index]?.answerRangeStart || "-"}-${questionWiseAnalysis?.sections[section_index]?.questions[question_index]?.answerRangeEnd|| ""}`}
                        </span>
                      </div>
                    )}
                    {question.solution && (
                      <div>
                        <span className="question-paper-solution">
                          Solution:{" "}
                        </span>

                        <div
                          dangerouslySetInnerHTML={{
                            __html: question.solution,
                          }}
                        />
                      </div>
                    )}
                    {
                      <QuestionsInfo
                        section_index={section_index}
                        question_index={question_index}
                        testObject={testObject}
                      />
                    }
                  </div>
                );
              })}
            </>
          ))}
        </div>
        {changeView ? (
          <div className="center instruction-back-button">
            <button
              className="btn btn-info text-center"
              onClick={() => changeView("question")}
            >
              Back
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default QuestionPaper;
